import React from "react";

import { COLOR } from "../component.constants";

export interface Props {
    color: COLOR;
    width?: number;
    height?: number;
    viewBoxWidth?: number;
    viewBoxHeight?: number;
}

const Search: React.FC<Props> = ({ color, width, height, viewBoxWidth, viewBoxHeight }) => {
    return (
        <svg
            width={width ?? 24}
            height={height ?? 24}
            viewBox={`0 0 ${viewBoxWidth ?? 24} ${viewBoxHeight ?? 24}`}
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            aria-hidden="true"
        >
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M13.915 6.53a5.222 5.222 0 1 0-7.385 7.385 5.222 5.222 0 0 0 7.385-7.385Zm-8.8-1.415a7.222 7.222 0 0 1 10.873 9.458l4.72 4.72a1 1 0 0 1-1.415 1.414l-4.72-4.72A7.224 7.224 0 0 1 5.115 5.116Z"
                fill={color}
            ></path>
        </svg>
    );
};

export default Search;
